import { css } from '@emotion/core';
import { typography } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';

export const linkBaseCss = css({
  cursor: 'pointer',
  display: 'inline-block',
  padding: 0,
  textDecoration: 'none',
  WebkitAppearance: 'none',
});

export const regularFontCss = css(typography.effra18, {
  ...linkBaseCss,
});

export const smallFontCss = css(typography.effra16, {
  ...linkBaseCss,
});

export const largeFontCss = css(typography.effra28, {
  ...linkBaseCss,
});

export const redTextCss = css({
  color: colorsPalette.red,
});

export const greyTextCss = css({
  color: colorsPalette.grey60,
});

export const blackTextCss = css({
  color: colorsPalette.black,
});

export const redUnderlineCss = css({
  borderBottom: `1px solid ${colorsPalette.red20}`,
  a: {
    color: colorsPalette.red,
    textDecoration: 'none',
  },
});

export const greyUnderlineCss = css({
  borderBottom: `1px solid ${colorsPalette.grey20}`,
  a: {
    color: colorsPalette.grey60,
    textDecoration: 'none',
  },
});

export const arrowCss = {
  display: 'inline-block',
  fontSize: 14,
  transform: 'translateY(3px)',
};

export const arrowStartCss = {
  marginRight: 15,
};

export const arrowEndCss = {
  marginLeft: 8,
};

export const arrowDownCss = css({
  transform: 'rotate(90deg)',
});

export const arrowLeftCss = css({
  transform: 'rotate(180deg)',
});
